'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonchangedtodrg = require('./commonchangedtodrg.html');

var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);

var _commonchangedtodrg3 = require('./commonchangedtodrg.controller');

var _commonchangedtodrg4 = _interopRequireDefault(_commonchangedtodrg3);

require('./commonchangedtodrg.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonchangedtodrgComponent = {
  restrict: 'E',
  bindings: {},
  template: _commonchangedtodrg2.default,
  controller: _commonchangedtodrg4.default,
  controllerAs: 'vm'
};

exports.default = commonchangedtodrgComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonchangedtodrg/commonchangedtodrg.component.js